import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, Component, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { TemplatePortal, PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';
import { AutoCompleteModule } from '@niceltd/sol/autocomplete';
import { ButtonModule } from '@niceltd/sol/button';
import { CheckboxModule } from '@niceltd/sol/checkbox';
import * as i2 from '@niceltd/sol/icon';
import { IconModule } from '@niceltd/sol/icon';
import * as i1$2 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import { TextInputModule } from '@niceltd/sol/text-input';
import { Subscription, merge } from 'rxjs';
import { Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import * as i3 from '@niceltd/sol/select';
import { SelectModule } from '@niceltd/sol/select';
function DropdownPlaceholderContainer_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "sol-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.placeHolderIcon);
  }
}
function DropdownPlaceholderContainer_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c0 = a0 => ({
  placeholderValue: a0
});
function DropdownPlaceholderContainer_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, DropdownPlaceholderContainer_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r1));
  }
}
function DropdownPlaceholderContainer_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.displayText);
  }
}
function DropdownPlaceholderContainer_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.placeholder);
  }
}
const _c1 = ["dropdownOverlay"];
function DropdownComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DropdownComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DropdownComponent_Conditional_1_Conditional_2_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r0.required ? 2 : -1);
  }
}
function DropdownComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r10.REQUIRED_ERROR_MESSAGE);
  }
}
function DropdownComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r11.errorMessageText);
  }
}
function DropdownComponent_Conditional_6_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropdownComponent_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropdownComponent_Conditional_6_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 14);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r8 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
  }
}
function DropdownComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, DropdownComponent_Conditional_6_Conditional_1_Template, 2, 1, "div", 12)(2, DropdownComponent_Conditional_6_Conditional_2_Template, 2, 1)(3, DropdownComponent_Conditional_6_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, !ctx_r3.isValid() && !ctx_r3.errorMessageText ? 1 : ctx_r3.errorMessageText ? 2 : ctx_r3.isMultiple && ctx_r3.maxSelectionLimit > 1 ? 3 : -1);
  }
}
function DropdownComponent_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropdownComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, DropdownComponent_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
  }
}
function DropdownComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-select", 15, 6);
    i0.ɵɵlistener("selectionChange", function DropdownComponent_ng_template_8_Template_sol_select_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.onSelectionChange($event));
    })("searchChanged", function DropdownComponent_ng_template_8_Template_sol_select_searchChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.onSearchChanged($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r5.options)("optionsLabel", ctx_r5.optionsLabel)("optionsValue", ctx_r5.optionsValue)("optionsIcon", ctx_r5.optionsIcon)("projectedContent", ctx_r5.optionTemplate)("isMultiple", ctx_r5.isMultiple)("selection", ctx_r5.selectionIds)("searchEnabled", ctx_r5.searchEnabled)("searchFunction", ctx_r5.searchFunction)("maxSelectionLimit", ctx_r5.maxSelectionLimit);
  }
}
function DropdownComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, "upToXItems", ctx_r7.maxSelectionLimit));
  }
}
class DropdownOverlayDirective {
  constructor(overlay, viewContainerRef) {
    this.overlay = overlay;
    this.viewContainerRef = viewContainerRef;
    this.isOverlayOpen = false;
    this.dropdownClosingActionsSub = Subscription.EMPTY;
    this.dropdownKeydownSub = Subscription.EMPTY;
    this.overlayChanged = new EventEmitter();
  }
  toggleDropdownOverlay(event) {
    event.preventDefault();
    if (!this.isOverlayOpen && !this.disabled) {
      this.openDropdown();
    } else {
      this.destroyDropdownOverlay();
    }
  }
  openDropdown() {
    const refElement = this.refContainer;
    this.isOverlayOpen = true;
    this.overlayRef = this.overlay.create({
      width: refElement.offsetWidth,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      panelClass: 'sol-dropdown-options-panel',
      scrollStrategy: this.overlay.scrollStrategies.close(),
      positionStrategy: this.overlay.position().flexibleConnectedTo(this.refContainer).withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 4,
        offsetX: 0
      }, {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -4,
        offsetX: 0
      }])
    });
    const templatePortal = new TemplatePortal(this.projectedContent, this.viewContainerRef);
    this.overlayRef.attach(templatePortal);
    this.dropdownClosingActionsSub = this.dropdownClosingActions().subscribe(() => this.destroyDropdownOverlay());
    this.dropdownKeydownSub = this.overlayRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.destroyDropdownOverlay();
      }
    });
    this.overlayChanged.emit(true);
  }
  dropdownClosingActions() {
    const backdropClick$ = this.overlayRef.backdropClick();
    const detachment$ = this.overlayRef.detachments();
    return merge(backdropClick$, detachment$);
  }
  destroyDropdownOverlay() {
    if (!this.overlayRef || !this.isOverlayOpen) {
      return;
    }
    this.dropdownClosingActionsSub.unsubscribe();
    this.dropdownKeydownSub.unsubscribe();
    this.isOverlayOpen = false;
    this.overlayRef.detach();
    this.overlayChanged.emit(false);
  }
  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
  static {
    this.ɵfac = function DropdownOverlayDirective_Factory(t) {
      return new (t || DropdownOverlayDirective)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DropdownOverlayDirective,
      selectors: [["", "solDropdownOverlay", ""]],
      hostBindings: function DropdownOverlayDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DropdownOverlayDirective_click_HostBindingHandler($event) {
            return ctx.toggleDropdownOverlay($event);
          })("keydown.enter", function DropdownOverlayDirective_keydown_enter_HostBindingHandler($event) {
            return ctx.toggleDropdownOverlay($event);
          });
        }
      },
      inputs: {
        projectedContent: "projectedContent",
        refContainer: "refContainer",
        disabled: "disabled"
      },
      outputs: {
        overlayChanged: "overlayChanged"
      },
      exportAs: ["solDropdownOverlay"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownOverlayDirective, [{
    type: Directive,
    args: [{
      selector: '[solDropdownOverlay]',
      host: {
        '(click)': 'toggleDropdownOverlay($event)',
        '(keydown.enter)': 'toggleDropdownOverlay($event)'
      },
      exportAs: 'solDropdownOverlay'
    }]
  }], () => [{
    type: i1.Overlay
  }, {
    type: i0.ViewContainerRef
  }], {
    projectedContent: [{
      type: Input
    }],
    refContainer: [{
      type: Input,
      args: ['refContainer']
    }],
    disabled: [{
      type: Input
    }],
    overlayChanged: [{
      type: Output
    }]
  });
})();
class DropdownPlaceholderContainer {
  constructor() {
    this.placeHolderIcon = null;
    this.placeholder = '';
    this.displayText = '';
    this.readOnly = false;
    this.disabled = false;
    this.isOpen = false;
    this.errorState = true;
  }
  static {
    this.ɵfac = function DropdownPlaceholderContainer_Factory(t) {
      return new (t || DropdownPlaceholderContainer)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DropdownPlaceholderContainer,
      selectors: [["sol-dropdown-placeholder"]],
      inputs: {
        placeHolderIcon: "placeHolderIcon",
        placeholder: "placeholder",
        displayText: "displayText",
        selectionTemplate: "selectionTemplate",
        readOnly: "readOnly",
        disabled: "disabled",
        isOpen: "isOpen",
        errorState: "errorState"
      },
      decls: 7,
      vars: 15,
      consts: [["tabindex", "0", 1, "sol-dropdown-placeholder"], ["class", "sol-option-icon"], ["class", "placeholder-template sol-dropdown-content"], [1, "sol-dropdown-icon"], [3, "icon", "className", "height", "width", "ariaHidden"], [1, "sol-option-icon"], [3, "icon"], [1, "placeholder-template", "sol-dropdown-content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "sol-dropdown-content", "display-text"], [1, "sol-dropdown-content", "placeholder-text"]],
      template: function DropdownPlaceholderContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, DropdownPlaceholderContainer_Conditional_1_Template, 2, 1, "div", 1)(2, DropdownPlaceholderContainer_Conditional_2_Template, 2, 4, "div", 2)(3, DropdownPlaceholderContainer_Conditional_3_Template, 2, 1)(4, DropdownPlaceholderContainer_Conditional_4_Template, 2, 1);
          i0.ɵɵelementStart(5, "div", 3);
          i0.ɵɵelement(6, "sol-icon", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("disabled", ctx.disabled)("error", ctx.errorState)("open", ctx.isOpen);
          i0.ɵɵadvance();
          i0.ɵɵconditional(1, ctx.placeHolderIcon ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(2, ctx.selectionTemplate ? 2 : ctx.displayText ? 3 : 4);
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("open", ctx.isOpen);
          i0.ɵɵadvance();
          i0.ɵɵproperty("icon", "sol-dropdown-arrow")("className", "sol-dropdown-arrow")("height", "1rem")("width", "1rem")("ariaHidden", true);
        }
      },
      dependencies: [i1$1.NgTemplateOutlet, i2.IconComponent],
      styles: [":root{--placeholder-border-style: 1px solid #999;--placeholder-width: 100%;--placeholder-height: 2.25rem;--placeholder-border-radius: 4px}.sol-dropdown-placeholder{border:var(--placeholder-border-style);width:var(--placeholder-width);height:var(--placeholder-height);border-radius:var(--placeholder-border-radius);box-sizing:border-box;display:flex;align-items:center;flex-direction:row;justify-content:flex-start;cursor:pointer;-webkit-user-select:none;user-select:none;background:var(--color-button-text-normal)}.sol-dropdown-placeholder:hover{background-color:var(--color-globalstate-hover-background);border-color:var(--color-globalstate-hover-border)}.sol-dropdown-placeholder:active{background-color:var(--color-interface-background50);border-color:var(--color-globalstate-active-border)}.sol-dropdown-placeholder:focus-visible{outline:solid 1px var(--color-globalstate-focus);outline-offset:.188rem;background-color:var(--color-globalstate-hover-background);border-color:var(--color-globalstate-hover-border)}.sol-dropdown-placeholder.error{border-color:var(--color-interface-error600);background-color:#fff}.sol-dropdown-placeholder .sol-option-icon{padding-left:.625rem;display:flex}.sol-dropdown-placeholder .sol-dropdown-content{box-sizing:border-box;padding-left:.625rem;text-transform:var(--typography-opensans-body-body3-text-case);text-indent:var(--typography-opensans-body-body3-paragraph-indent);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);font-stretch:var(--typography-opensans-body-body3-font-stretch);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-family:var(--typography-opensans-body-body3-font-family);text-decoration:var(--typography-opensans-body-body3-text-decoration);font-size:var(--typography-opensans-body-body3-font-size);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-dropdown-placeholder .sol-dropdown-content.display-text{color:var(--color-globalstate-active-content)}.sol-dropdown-placeholder .sol-dropdown-content.placeholder-text{color:var(--color-globalstate-inactive-text)}.sol-dropdown-placeholder .placeholder-template{display:flex;gap:.313rem}.sol-dropdown-placeholder .placeholder-template .template-txt{margin-top:.188rem}.sol-dropdown-placeholder .sol-dropdown-icon{box-sizing:border-box;display:flex;align-items:center;margin:0 .5rem 0 auto;height:1rem;width:1rem}.sol-dropdown-placeholder .sol-dropdown-icon.open{transform:rotate(180deg)}.sol-dropdown-placeholder .sol-dropdown-icon svg{fill:var(--color-globalstate-inactive-icon)}.sol-dropdown-placeholder.disabled{background-color:var(--color-globalstate-disabled-background);border-color:var(--color-globalstate-disabled-border);cursor:not-allowed;pointer-events:none}.sol-dropdown-placeholder.disabled .content{color:var(--color-globalstate-disabled-content)}.sol-dropdown-placeholder.disabled .sol-dropdown-icon svg{fill:var(--color-globalstate-disabled-border)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownPlaceholderContainer, [{
    type: Component,
    args: [{
      selector: 'sol-dropdown-placeholder',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"sol-dropdown-placeholder\" [class.disabled]=\"disabled\" [class.error]=\"errorState\" [class.open]=\"isOpen\" tabindex=\"0\">\n  @if (placeHolderIcon) {\n    <div class=\"sol-option-icon\"><sol-icon [icon]=\"placeHolderIcon\"></sol-icon></div>\n  }\n  @if (selectionTemplate) {\n    <div class=\"placeholder-template sol-dropdown-content\">\n      <ng-container *ngTemplateOutlet=\"selectionTemplate; context: { placeholderValue: this }\"></ng-container>\n    </div>\n  } @else if (displayText) {\n    <div class=\"sol-dropdown-content display-text\">{{ displayText }}</div>\n  } @else {\n    <div class=\"sol-dropdown-content placeholder-text\">{{ placeholder }}</div>\n  }\n  <div class=\"sol-dropdown-icon\" [class.open]=\"isOpen\">\n    <sol-icon [icon]=\"'sol-dropdown-arrow'\" [className]=\"'sol-dropdown-arrow'\" [height]=\"'1rem'\" [width]=\"'1rem'\" [ariaHidden]=\"true\"></sol-icon>\n  </div>\n</div>\n",
      styles: [":root{--placeholder-border-style: 1px solid #999;--placeholder-width: 100%;--placeholder-height: 2.25rem;--placeholder-border-radius: 4px}.sol-dropdown-placeholder{border:var(--placeholder-border-style);width:var(--placeholder-width);height:var(--placeholder-height);border-radius:var(--placeholder-border-radius);box-sizing:border-box;display:flex;align-items:center;flex-direction:row;justify-content:flex-start;cursor:pointer;-webkit-user-select:none;user-select:none;background:var(--color-button-text-normal)}.sol-dropdown-placeholder:hover{background-color:var(--color-globalstate-hover-background);border-color:var(--color-globalstate-hover-border)}.sol-dropdown-placeholder:active{background-color:var(--color-interface-background50);border-color:var(--color-globalstate-active-border)}.sol-dropdown-placeholder:focus-visible{outline:solid 1px var(--color-globalstate-focus);outline-offset:.188rem;background-color:var(--color-globalstate-hover-background);border-color:var(--color-globalstate-hover-border)}.sol-dropdown-placeholder.error{border-color:var(--color-interface-error600);background-color:#fff}.sol-dropdown-placeholder .sol-option-icon{padding-left:.625rem;display:flex}.sol-dropdown-placeholder .sol-dropdown-content{box-sizing:border-box;padding-left:.625rem;text-transform:var(--typography-opensans-body-body3-text-case);text-indent:var(--typography-opensans-body-body3-paragraph-indent);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);font-stretch:var(--typography-opensans-body-body3-font-stretch);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-family:var(--typography-opensans-body-body3-font-family);text-decoration:var(--typography-opensans-body-body3-text-decoration);font-size:var(--typography-opensans-body-body3-font-size);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-dropdown-placeholder .sol-dropdown-content.display-text{color:var(--color-globalstate-active-content)}.sol-dropdown-placeholder .sol-dropdown-content.placeholder-text{color:var(--color-globalstate-inactive-text)}.sol-dropdown-placeholder .placeholder-template{display:flex;gap:.313rem}.sol-dropdown-placeholder .placeholder-template .template-txt{margin-top:.188rem}.sol-dropdown-placeholder .sol-dropdown-icon{box-sizing:border-box;display:flex;align-items:center;margin:0 .5rem 0 auto;height:1rem;width:1rem}.sol-dropdown-placeholder .sol-dropdown-icon.open{transform:rotate(180deg)}.sol-dropdown-placeholder .sol-dropdown-icon svg{fill:var(--color-globalstate-inactive-icon)}.sol-dropdown-placeholder.disabled{background-color:var(--color-globalstate-disabled-background);border-color:var(--color-globalstate-disabled-border);cursor:not-allowed;pointer-events:none}.sol-dropdown-placeholder.disabled .content{color:var(--color-globalstate-disabled-content)}.sol-dropdown-placeholder.disabled .sol-dropdown-icon svg{fill:var(--color-globalstate-disabled-border)}\n"]
    }]
  }], null, {
    placeHolderIcon: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    displayText: [{
      type: Input
    }],
    selectionTemplate: [{
      type: Input
    }],
    readOnly: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    isOpen: [{
      type: Input
    }],
    errorState: [{
      type: Input
    }]
  });
})();
let dropdownCount = 0;
class DropdownComponent {
  set selection(selection) {
    this._selection = selection;
    if (Array.isArray(selection)) {
      this._selectionIds = this.getOptionsIdArray(selection);
    } else if (selection) {
      this._selectionIds = selection[this.optionsValue];
    } else {
      this._selectionIds = [];
    }
    this.setPlaceholderDisplayText();
  }
  get selection() {
    return this._selection;
  }
  get selectionIds() {
    return this._selectionIds;
  }
  get maxSelectionLimit() {
    return this._maxSelectionLimit;
  }
  set maxSelectionLimit(value) {
    // Ensure default value is 0 if undefined or null
    this._maxSelectionLimit = value || 1;
    if (value < 1) {
      console.error('Minimum selection limit should be 2. Setting to default value 1');
      this._maxSelectionLimit = 1;
    } else if (value > 250) {
      console.error('Maximum selection limit should be 250');
      this._maxSelectionLimit = 250;
    }
  }
  constructor(cdr, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this._selection = [];
    this._selectionIds = [];
    this.placeHolderIcon = null;
    this._touched = false;
    this.overlayChangedSubscription = Subscription.EMPTY;
    this._validatorOnChange = () => {};
    /**
     * Method set in `registerOnChange` to propagate changes back to the form.
     */
    this._onChangeFn = _ => {};
    /**
     * Called when dropdown is blurred. Needed to properly implement `ControlValueAccessor`.
     */
    this._onTouchedFn = () => {};
    this.placeholder = '';
    this.label = '';
    this.id = '';
    this.name = '';
    this.errorMessageText = null;
    this.optionsLabel = 'name';
    this.optionsValue = 'value';
    this.optionsIcon = 'icon';
    this.disabled = false;
    this.required = false;
    this.isMultiple = false;
    this.searchEnabled = false;
    this.options = [];
    this._maxSelectionLimit = 1;
    this.supportErrorMessage = false;
    this.placeholderDisplayText = '';
    this.isOverlayOpen = false;
    this.dropdownOpenStateChange = new EventEmitter();
    this.selectionChange = new EventEmitter();
    this.searchChanged = new EventEmitter();
    this.REQUIRED_ERROR_MESSAGE = this.translationService.getTranslation('fieldRequired');
    dropdownCount++;
    this.defaultId = `sol-dropdown-${dropdownCount}`;
  }
  ngOnInit() {
    this.setPlaceholderDisplayText();
  }
  ngAfterViewInit() {
    this.overlayChangedSubscription = this.dropdownOverlay.overlayChanged.subscribe(state => {
      this.overlayChange(state);
    });
  }
  onSelectionChange(value) {
    if (Array.isArray(value)) {
      this.selection = this.getOptions(value);
    } else {
      this.selection = this.getOption(value);
      this.dropdownOverlay.destroyDropdownOverlay();
    }
    this._onChangeFn(this.selection);
    this.selectionChange.emit(this.selection);
  }
  onSearchChanged($event) {
    this.searchChanged.emit($event);
  }
  getOptionLabel(option) {
    return option ? option[this.optionsLabel] : '';
  }
  getOptionIcon(option) {
    return option ? option[this.optionsIcon] : '';
  }
  getOption(optionValue) {
    return this.options.find(option => option[this.optionsValue] === optionValue);
  }
  getOptions(optionsValueArray) {
    return optionsValueArray.map(optionValue => this.getOption(optionValue));
  }
  getOptionsIdArray(options) {
    return options.map(option => option[this.optionsValue]);
  }
  setPlaceholderDisplayText() {
    this.placeHolderIcon = null;
    if (this.isMultiple) {
      if (Array.isArray(this.selection) && this.selection.length > 1) {
        this.placeholderDisplayText = this.translationService.getTranslation('dropdownItemSelectedText', this.selection.length);
      } else if (Array.isArray(this.selection) && this.selection.length === 1) {
        this.placeholderDisplayText = this.getOptionLabel(this.selection[0]);
        this.placeHolderIcon = this.getOptionIcon(this.selection[0]);
      } else {
        this.placeholderDisplayText = '';
      }
    } else if (this.selection && this.selection[this.optionsValue]) {
      this.placeholderDisplayText = this.selection[this.optionsLabel];
      this.placeHolderIcon = this.getOptionIcon(this.selection[0]);
    } else {
      this.placeholderDisplayText = '';
    }
  }
  overlayChange(state) {
    this.isOverlayOpen = state;
    this.dropdownOpenStateChange.emit(state);
    if (!state) {
      this.markAsTouched();
    }
  }
  writeValue(obj) {
    this.selection = obj;
  }
  registerOnChange(fn) {
    this._onChangeFn = fn;
  }
  registerOnTouched(fn) {
    this._onTouchedFn = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.cdr.detectChanges();
  }
  focusout() {
    if (this._touched) {
      this._onTouchedFn();
    }
  }
  markAsTouched() {
    if (!this._touched) {
      this._touched = true;
      this._onTouchedFn();
      this.cdr.detectChanges();
    }
  }
  onKeydown(event) {
    if (event.key === 'Tab') {
      this.markAsTouched();
    }
  }
  /** Implemented as a part of Validator. */
  validate(control) {
    let isValid = false;
    if (this.selection && Array.isArray(this.selection) && this.selection.length > 1 || this.selection) {
      isValid = true;
    }
    if (control.hasValidator(Validators.required)) {
      this.required = true;
    }
    return this.required && !isValid ? {
      required: true
    } : null;
  }
  /** Implemented as a part of Validator. */
  registerOnValidatorChange(fn) {
    this._validatorOnChange = fn;
  }
  isValid() {
    let valid = true;
    let hasValue = false;
    if (this.selection && Array.isArray(this.selection)) {
      hasValue = this.selection.length > 0;
    } else if (this.selection) {
      hasValue = true;
    }
    if (this.required && !hasValue && this._touched) {
      valid = false;
    }
    return valid;
  }
  ngOnDestroy() {
    this.overlayChangedSubscription.unsubscribe();
  }
  static {
    this.ɵfac = function DropdownComponent_Factory(t) {
      return new (t || DropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DropdownComponent,
      selectors: [["sol-dropdown"]],
      viewQuery: function DropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownOverlay = _t.first);
        }
      },
      inputs: {
        searchFunction: "searchFunction",
        placeholder: "placeholder",
        label: "label",
        id: "id",
        name: "name",
        errorMessageText: "errorMessageText",
        optionsLabel: "optionsLabel",
        optionsValue: "optionsValue",
        optionsIcon: "optionsIcon",
        disabled: "disabled",
        required: "required",
        isMultiple: "isMultiple",
        searchEnabled: "searchEnabled",
        options: "options",
        selection: "selection",
        maxSelectionLimit: "maxSelectionLimit",
        supportErrorMessage: "supportErrorMessage",
        optionTemplate: "optionTemplate",
        selectedOptionTemplate: "selectedOptionTemplate"
      },
      outputs: {
        dropdownOpenStateChange: "dropdownOpenStateChange",
        selectionChange: "selectionChange",
        searchChanged: "searchChanged"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: DropdownComponent,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: DropdownComponent,
        multi: true
      }])],
      decls: 12,
      vars: 13,
      consts: [[1, "sol-dropdown", 3, "id"], ["class", "sol-dropdown-label"], ["container", ""], ["solDropdownOverlay", "", 3, "placeHolderIcon", "placeholder", "displayText", "selectionTemplate", "isOpen", "disabled", "errorState", "projectedContent", "refContainer", "focusout", "keydown"], ["dropdownOverlay", "solDropdownOverlay"], ["class", "message"], ["select", ""], ["maxSelectionMessage", ""], [1, "sol-dropdown-label"], ["class", "sol-dropdown-required"], [1, "sol-dropdown-required"], [1, "message"], ["class", "error-message"], [1, "error-message"], [4, "ngTemplateOutlet"], [1, "sol-select-cls", 3, "options", "optionsLabel", "optionsValue", "optionsIcon", "projectedContent", "isMultiple", "selection", "searchEnabled", "searchFunction", "maxSelectionLimit", "selectionChange", "searchChanged"], [1, "text-message"]],
      template: function DropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, DropdownComponent_Conditional_1_Template, 3, 2, "div", 1);
          i0.ɵɵelementStart(2, "div", null, 2)(4, "sol-dropdown-placeholder", 3, 4);
          i0.ɵɵlistener("focusout", function DropdownComponent_Template_sol_dropdown_placeholder_focusout_4_listener() {
            return ctx.focusout();
          })("keydown", function DropdownComponent_Template_sol_dropdown_placeholder_keydown_4_listener($event) {
            return ctx.onKeydown($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(6, DropdownComponent_Conditional_6_Template, 4, 1, "div", 5)(7, DropdownComponent_Conditional_7_Template, 2, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, DropdownComponent_ng_template_8_Template, 2, 10, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(10, DropdownComponent_ng_template_10_Template, 3, 4, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(3);
          const _r6 = i0.ɵɵreference(9);
          i0.ɵɵproperty("id", ctx.id || ctx.defaultId);
          i0.ɵɵattribute("data-name", ctx.name);
          i0.ɵɵadvance();
          i0.ɵɵconditional(1, ctx.label ? 1 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("placeHolderIcon", ctx.placeHolderIcon)("placeholder", ctx.placeholder)("displayText", ctx.placeholderDisplayText)("selectionTemplate", ctx.selectedOptionTemplate)("isOpen", ctx.isOverlayOpen)("disabled", ctx.disabled)("errorState", ctx.errorMessageText ? true : !ctx.isValid())("projectedContent", _r6)("refContainer", _r1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(6, ctx.supportErrorMessage ? 6 : ctx.isMultiple && ctx.maxSelectionLimit > 1 ? 7 : -1);
        }
      },
      dependencies: [i1$1.NgTemplateOutlet, i3.SelectComponent, DropdownPlaceholderContainer, DropdownOverlayDirective, i1$2.TranslationPipe],
      styles: [".sol-dropdown{width:100%}.sol-dropdown .sol-dropdown-label{letter-spacing:var(--typography-opensans-body-overline-paragraph-spacing);line-height:var(--typography-opensans-body-overline-line-height);font-stretch:var(--typography-opensans-body-overline-font-stretch);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-family:var(--typography-opensans-body-overline-font-family);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-size:var(--typography-opensans-body-overline-font-size);text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-globalstate-inactive-text);align-items:center;display:flex;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:.25rem}.sol-dropdown .sol-dropdown-label .sol-dropdown-required{color:var(--color-interface-error600);padding-left:.25rem}.sol-dropdown .message{height:.938rem;padding:.313rem 0 0 .125rem;color:var(--color-text-secondary);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);font-size:var(--typography-opensans-body-body4-font-size);line-height:var(--typography-opensans-body-body4-line-height);text-decoration:var(--typography-opensans-body-body4-text-decoration);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);text-transform:var(--typography-opensans-body-body4-text-case)}.sol-dropdown .message .error-message{color:var(--color-interface-error600)}.sol-select-cls{width:100%}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComponent, [{
    type: Component,
    args: [{
      selector: 'sol-dropdown',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: DropdownComponent,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: DropdownComponent,
        multi: true
      }],
      template: "<div class=\"sol-dropdown\" [id]=\"id || defaultId\" [attr.data-name]=\"name\">\n  @if (label) {\n    <div class=\"sol-dropdown-label\">\n      {{ label }}\n      @if (required) {\n        <span class=\"sol-dropdown-required\">*</span>\n      }\n    </div>\n  }\n  <div #container>\n    <sol-dropdown-placeholder\n      [placeHolderIcon]=\"placeHolderIcon\"\n      [placeholder]=\"placeholder\"\n      [displayText]=\"placeholderDisplayText\"\n      [selectionTemplate]=\"selectedOptionTemplate\"\n      [isOpen]=\"isOverlayOpen\"\n      [disabled]=\"disabled\"\n      [errorState]=\"errorMessageText ? true : !isValid()\"\n      #dropdownOverlay=\"solDropdownOverlay\"\n      solDropdownOverlay\n      [projectedContent]=\"select\"\n      [refContainer]=\"container\"\n      (focusout)=\"focusout()\"\n      (keydown)=\"onKeydown($event)\"\n    ></sol-dropdown-placeholder>\n  </div>\n  @if (supportErrorMessage) {\n    <div class=\"message\">\n      @if (!isValid() && !errorMessageText) {\n        <div class=\"error-message\">{{ REQUIRED_ERROR_MESSAGE }}</div>\n      } @else if (errorMessageText) {\n        <div class=\"error-message\">{{ errorMessageText }}</div>\n      } @else if (isMultiple && maxSelectionLimit > 1) {\n        <ng-container *ngTemplateOutlet=\"maxSelectionMessage\"></ng-container>\n      }\n    </div>\n  } @else if (isMultiple && maxSelectionLimit > 1) {\n    <div class=\"message\">\n      <ng-container *ngTemplateOutlet=\"maxSelectionMessage\"></ng-container>\n    </div>\n  }\n</div>\n\n<ng-template #select>\n  <sol-select\n    #select\n    [options]=\"options\"\n    class=\"sol-select-cls\"\n    [optionsLabel]=\"optionsLabel\"\n    [optionsValue]=\"optionsValue\"\n    [optionsIcon]=\"optionsIcon\"\n    [projectedContent]=\"optionTemplate\"\n    [isMultiple]=\"isMultiple\"\n    [selection]=\"selectionIds\"\n    [searchEnabled]=\"searchEnabled\"\n    [searchFunction]=\"searchFunction\"\n    [maxSelectionLimit]=\"maxSelectionLimit\"\n    (selectionChange)=\"onSelectionChange($event)\"\n    (searchChanged)=\"onSearchChanged($event)\"\n  ></sol-select>\n</ng-template>\n\n<ng-template #maxSelectionMessage>\n  <div class=\"text-message\">{{ 'upToXItems' | translate: maxSelectionLimit }}</div>\n</ng-template>\n",
      styles: [".sol-dropdown{width:100%}.sol-dropdown .sol-dropdown-label{letter-spacing:var(--typography-opensans-body-overline-paragraph-spacing);line-height:var(--typography-opensans-body-overline-line-height);font-stretch:var(--typography-opensans-body-overline-font-stretch);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-family:var(--typography-opensans-body-overline-font-family);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-size:var(--typography-opensans-body-overline-font-size);text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-globalstate-inactive-text);align-items:center;display:flex;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:.25rem}.sol-dropdown .sol-dropdown-label .sol-dropdown-required{color:var(--color-interface-error600);padding-left:.25rem}.sol-dropdown .message{height:.938rem;padding:.313rem 0 0 .125rem;color:var(--color-text-secondary);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);font-size:var(--typography-opensans-body-body4-font-size);line-height:var(--typography-opensans-body-body4-line-height);text-decoration:var(--typography-opensans-body-body4-text-decoration);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);text-transform:var(--typography-opensans-body-body4-text-case)}.sol-dropdown .message .error-message{color:var(--color-interface-error600)}.sol-select-cls{width:100%}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$2.TranslationService
  }], {
    searchFunction: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    errorMessageText: [{
      type: Input
    }],
    optionsLabel: [{
      type: Input
    }],
    optionsValue: [{
      type: Input
    }],
    optionsIcon: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    isMultiple: [{
      type: Input
    }],
    searchEnabled: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    selection: [{
      type: Input
    }],
    maxSelectionLimit: [{
      type: Input
    }],
    supportErrorMessage: [{
      type: Input
    }],
    optionTemplate: [{
      type: Input
    }],
    selectedOptionTemplate: [{
      type: Input
    }],
    dropdownOpenStateChange: [{
      type: Output
    }],
    selectionChange: [{
      type: Output
    }],
    searchChanged: [{
      type: Output
    }],
    dropdownOverlay: [{
      type: ViewChild,
      args: ['dropdownOverlay']
    }]
  });
})();
const components = [DropdownComponent, DropdownPlaceholderContainer, DropdownOverlayDirective];
class DropdownModule {
  static {
    this.ɵfac = function DropdownModule_Factory(t) {
      return new (t || DropdownModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DropdownModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AutoCompleteModule, CommonModule, ButtonModule, CheckboxModule, IconModule, TextInputModule, TranslationModule, OverlayModule, PortalModule, A11yModule, SelectModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownModule, [{
    type: NgModule,
    args: [{
      declarations: components,
      imports: [AutoCompleteModule, CommonModule, ButtonModule, CheckboxModule, IconModule, TextInputModule, TranslationModule, OverlayModule, PortalModule, A11yModule, SelectModule],
      exports: components
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DropdownComponent, DropdownModule, DropdownOverlayDirective, DropdownPlaceholderContainer };
